export enum TickerItemPhase {
    PregameStart = 'pregame_start',
    Start = 'start',
    FirstHalfStart = 'regular.firsthalf.start',
    FirstHalfEnd = 'regular.firsthalf.end',
    SecondHalfStart = 'regular.secondhalf.start',
    SecondHalfEnd = 'regular.secondhalf.end',
    OtFirstHalfStart = 'overtime.firsthalf.start',
    OtFistHalfEnd = 'overtime.firsthalf.end',
    OtSecondHalfStart = 'overtime.secondhalf.start',
    OtSecondHalfEnd = 'overtime.secondhalf.end',
    PenaltyShootoutStart = 'overtime.shootout.start',
    PenaltyShootout = 'overtime.shootout',
    End = 'end',
    Now = 'now',
}
